<template>
  <div
    class="product-graduated-prices"
  >
    <table
      class="product-graduated-prices__list"
      :class="isProductList ? 'product-box' : ''"
    >
      <thead>
        <tr v-if="isProductList">
          <th
            v-html="display_string"
          />
          <th />
          <th
            class="price"
          >
            <div
              v-html="$t('ads.graduated_prices.amount2', [graduated_prices[graduated_prices.length - 1].isReduced
                ? graduated_prices[graduated_prices.length - 1].reducedPrice : graduated_prices[graduated_prices.length - 1].price])"
            />
            <div
              class="price-including-tax"
              v-html="$t('ads.graduated_prices.amount.including.tax')"
            />
          </th>
        </tr>
        <tr v-else>
          <th />
          <th
            class="product-graduated-prices__th-bold"
            v-html="$t('ads.graduated_prices.amount', [display_string])"
          />
          <th
            class="product-graduated-prices__table-header product-graduated-prices__adp-price-th"
          >
            <div
              class="product-graduated-prices__th-bold"
              v-html="$t('ads.graduated_prices.price', [display_string])"
            />
            <div>{{ $t('ads.main.total_sum.excluding.tax') }}</div>
          </th>
          <th class="product-graduated-prices__table-header product-graduated-prices__adp-price-th">
            <div
              class="product-graduated-prices__th-bold"
              v-html="$t('ads.graduated_prices.grossPrice', [display_string])"
            />
            <div>{{ $t('ads.main.total_sum.including.tax') }}</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-if="isProductList">
          <tr
            class="product-graduated-prices__price-line"
            @click.prevent="toPdp(graduated_prices[0].from)"
          >
            <td>
              {{ graduated_prices[0].from }}
            </td>
            <td
              class="savings"
            >
              {{ graduated_prices[0].savings }}
            </td>
            <td
              class="price"
            >
              <template v-if="graduated_prices[0].isReduced">
                {{ graduated_prices[0].reducedPrice }}
                <span class="price--old">
                  {{ graduated_prices[0].price }}
                </span>
              </template>
              <template v-else>
                {{ graduated_prices[0].price }}
              </template>
            </td>
          </tr>
          <tr
            class="product-graduated-prices__price-line"
            @click.prevent="toPdp(graduated_prices[2].from)"
            v-if="graduated_prices.length > 3"
          >
            <td>
              {{ graduated_prices[2].from }}
            </td>
            <td
              class="savings"
            >
              {{ graduated_prices[2].savings }}
            </td>
            <td
              class="price"
            >
              <template v-if="graduated_prices[2].isReduced">
                {{ graduated_prices[2].reducedPrice }}
                <span class="price--old">
                  {{ graduated_prices[2].price }}
                </span>
              </template>
              <template v-else>
                {{ graduated_prices[2].price }}
              </template>
            </td>
          </tr>
          <tr
            class="product-graduated-prices__price-line"
            @click.prevent="toPdp(graduated_prices[graduated_prices.length - 1].from)"
            v-if="graduated_prices.length > 1"
          >
            <td
              class="amount"
            >
              {{ graduated_prices[graduated_prices.length - 1].from }}
            </td>
            <td
              class="savings"
            >
              {{ graduated_prices[graduated_prices.length - 1].savings }}
            </td>
            <td
              class="price"
            >
              <template v-if="graduated_prices[graduated_prices.length - 1].isReduced">
                {{ graduated_prices[graduated_prices.length - 1].reducedPrice }}
                <span class="price--old">
                  {{ graduated_prices[graduated_prices.length - 1].price }}
                </span>
              </template>
              <template v-else>
                {{ graduated_prices[graduated_prices.length - 1].price }}
              </template>
            </td>
          </tr>
        </template>
        <tr
          class="product-graduated-prices__price-line"
          v-else
          v-for="(graduatedPrice, i) in graduated_prices"
          :key="i"
          :class="isActive(i) ? 'active' : ''"
          @click.prevent="changeGraduatedPriceValue(graduatedPrice.from)"
        >
          <td class="add-quantity">
            <span class="product-graduated-prices__add-quantity" />
          </td>
          <td
            class="amount"
          >
            {{ graduatedPrice.from }}
          </td>

          <td
            class="price adp-price"
            :class="{ 'adp-price-with-base': ((graduatedPrice.reducedBasePrice && graduatedPrice.reducedBasePrice !== null) || graduatedPrice.basePrice && graduatedPrice.basePrice !== null)}"
          >
            <template v-if="graduatedPrice.isReduced">
              <div
                :class="{ 'price-wrapper': graduatedPrice.reducedBasePrice && graduatedPrice.reducedBasePrice !== null }"
              >
                {{ graduatedPrice.reducedPrice }}
                <span class="price--old">
                  {{ graduatedPrice.price }}
                </span>
                <div class="base-price-container">
                  <span class="base-price">
                    {{ graduatedPrice.reducedBasePrice }}
                  </span>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                :class="{ 'price-wrapper': graduatedPrice.basePrice && graduatedPrice.basePrice !== null }"
              >
                {{ graduatedPrice.price }}
                <div class="base-price-container">
                  <span class="base-price">
                    {{ graduatedPrice.basePrice }}
                  </span>
                </div>
              </div>
            </template>
          </td>
          <td
            class="price"
          >
            <template v-if="graduatedPrice.isReduced">
              <div class="price-wrapper float-right">
                {{ graduatedPrice.reducedGrossPrice }}
                <span class="price--old">
                  {{ graduatedPrice.grossPrice }}
                </span>
                <div class="base-price-container">
                  <span class="base-price">
                    {{ graduatedPrice.reducedBaseGrossPrice }}
                  </span>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="price-wrapper float-right">
                {{ graduatedPrice.grossPrice }}
                <div class="base-price-container">
                  <span class="base-price">
                    {{ graduatedPrice.baseGrossPrice }}
                  </span>
                </div>
              </div>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    graduated_prices: {
      type: Array,
      default: () => []
    },
    name: String,
    display_string: String,
    editProduct: Boolean,
    isProductList: {
      type: Boolean,
      default: false
    },
    initialValue: Number,
    max: Number,
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value: 0,
      amount: 0,
      maxValue: this.max
    }
  },
  mounted() {
    if (this.initialValue) {
      this.value = this.initialValue
    }
  },
  emits: ['change'],
  methods: {
    isActive(index) {
      let value = this.getValue()
      this.maxValue = this.max !== undefined ? this.max : 9999999
      if (index !== undefined) {
        const sameValue = value >= this.graduated_prices[index].from
        const lastRange = this.graduated_prices[index + 1] !== undefined
          ? this.graduated_prices[index + 1].from : this.maxValue
        return sameValue && value < lastRange
      }
    },
    getActiveGraduatedPrice() {
      for (let i = 0; i < this.graduated_prices.length; i++) {
        if (this.isActive(i)) {
          return this.graduated_prices[i]
        }
      }
      return undefined
    },
    changeGraduatedPriceValue(amount) {
      this.amount = amount
      this.$emit('change', this.amount)
    },
    getAmount() {
      return this.amount
    },
    setAmount(newAmount) {
      this.amount = newAmount
    },
    getValue() {
      if (this.$parent.$refs.quantity !== undefined) {
        this.value = this.$parent.$refs.quantity.value
      }
      return parseInt(this.value)
    },
    toPdp(amount) {
      if (this.url === '') {
        return true
      }
      const currentURL = new URL(this.url)
      currentURL.searchParams.set('quantity', amount)
      window.location.href = currentURL.toString()
      return false
    }
  }
}

</script>
